<template>
  <div class="student-list">
    <el-table
      ref="multipleTable"
      :data="studentData"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <!-- <el-table-column label="#" type="index"> </el-table-column> -->
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="studentName"
        label="姓名"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column prop="sex" label="性别">
      </el-table-column>
      <el-table-column
        prop="studentNumber"
        label="学号"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="gradeName"
        label="年级"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="className"
        label="班级"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "修改学生信息",
      studentInfo: {},
      editShow: false,
    };
  },
  props: {
    studentData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      if (list.length == 0) return;
      this.$emit("addStudentDorm", list);
    },
  },
};
</script>

<style>
@import "./nomoved-studentlist.scss";
</style>